module.exports = {
      id: "logout-usage",
      viewBox: "0 0 75 28",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#logout",
      toString: function () {
        return this.url;
      }
    }